export interface Profile {
  name: string | null;
  email: string | null;
}

const text = (value: unknown) => (typeof value === 'string' && value.trim() ? value.trim() : null);
const record = (value: unknown) =>
  typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : null;

/**
 * 코어 `GET users/me` 응답에서 표시용 이름·이메일을 읽는다. 응답 스키마가 스펙에 없어 `{ data: {...} }` 래핑과
 * 평탄한 형태를 모두 받고, 없는 필드는 null로 둔다(사용자 메뉴가 "내 계정"으로 대신한다).
 */
export function parseProfile(response: unknown): Profile {
  const root = record(response);
  const body = record(root?.data) ?? root;
  const profile = record(body?.profile);
  const pick = (key: string) => text(body?.[key]) ?? text(profile?.[key]);
  return { name: pick('name') ?? pick('nickname'), email: pick('email') };
}
